/** Check all meta ref IDs (deep-link from Kayak, Google, etc)  */
export function getIsMeta(paramsObj) {
  const ACCEPTABLE_REF_ID_KEYS = ['ref-id', 'refid', 'r-id']
  const refId = ACCEPTABLE_REF_ID_KEYS.reduce((prev, key) => prev || paramsObj[key], null)
  return refId && refId !== 'DTDIRECT'
}
